import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  BrainEstreamComputeRangeRequest,
  BrainEstreamComputeRangeResponse,
} from 'brain-data/model/brain-estream-compute-range.model';

@Injectable({ providedIn: 'root' })
export class BrainEstreamComputeRangeService {
  constructor(private http: HttpClient) {}

  computeRange(
    request: BrainEstreamComputeRangeRequest,
  ): Observable<BrainEstreamComputeRangeResponse> {
    const payload: BrainEstreamComputeRangeRequest = {
      ...request,
      contractNumber: request.contractNumber.trim(),
    };
    return this.http.post<BrainEstreamComputeRangeResponse>(
      `${environment.apiBaseUrl}/brain/diff/contracts/compute-range`,
      payload,
    );
  }
}
